// extracted by mini-css-extract-plugin
module.exports = {"templateOption":"style-module__templateOption___31Q6V"};